<template lang="pug">
  nav.navbar.navbar-expand-lg.navbar-transparent.navbar-absolute
    .container-fluid
      .navbar-wrapper
        .navbar-toggle
          button.navbar-toggler(@click="$sidebar.show = !$sidebar.show")
            span.navbar-toggler-bar.bar1
            span.navbar-toggler-bar.bar2
            span.navbar-toggler-bar.bar3
      ul.navbar-nav(v-if="isAuth")
        li.nav-item.navbar-lang(v-for="lang in $i18n.availableLocales" :key="lang")
          a.nav-link(:class="{ active: lang === $i18n.locale }" @click.prevent="changeLang(lang)" href="javascript:")
            img(:src=`require('@/assets/img/flags/' + lang + '.png')`)
        li.nav-item
          span.nav-link
            span {{ displayName }}
        li.nav-item
          a.nav-link(href="javascript:" @click.prevent="logout")
            i.fas.fa-sign-out-alt
      ul.navbar-nav(v-else)
        li.nav-item
          RouterLink.nav-link(:to="{name: 'login'}") Войти
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters('auth', ['user', 'isAuth']),
    displayName: vm => vm.user?.email
  },
  methods: {
    ...mapActions('auth', ['logout']),
    changeLang (lang) {
      localStorage.setItem('locale', lang)
      location.reload()
    }
  }
}
</script>

<style lang="sass">
.nav-item.navbar-lang
  a.nav-link
    opacity: 0.3
    padding-right: 5px
    padding-left: 5px
    transition: opacity .2s

    &:hover
      opacity: 0.5

    &.active
      opacity: 1
</style>
